import { QuipUser } from './quipUserTypes';
import { Trial } from './trialTypes';

export type VoucherCode = {
  id: number;
  code: string;
  trialId: number;
  quipUserId?: number;
  claimedOn?: string; // ISO Date string
}

export type VoucherManagementType = VoucherCode & Pick<QuipUser, 'email' | 'title' | 'surname' | 'firstname'> & { enrollmentStatus?: string; }

export interface VoucherState {
  voucherData?: VoucherManagementType[];
  voucherDetail?: VoucherCode & {trial: Trial};
  fetchingVoucherData: boolean;
}

/** Redux action constants */

export const SET_VOUCHER_CODE = 'SET_VOUCHER_CODE';
export const FETCHING_VOUCHER_DATA = 'FETCHING_VOUCHER_DATA ';
export const SET_VOUCHER_DETAIL = 'SET_VOUCHER_DETAIL';

/** Action types */

type SetVoucherCodeAction = {
  type: typeof SET_VOUCHER_CODE;
  payload: VoucherManagementType[];
};

type SetFetchingVoucherData = {
  type: typeof FETCHING_VOUCHER_DATA;
  payload: boolean;
};

type SetVoucherDetail = {
  type: typeof SET_VOUCHER_DETAIL;
  payload: VoucherCode & {trial: Trial};
}
export type VoucherActionTypes = SetVoucherCodeAction | SetFetchingVoucherData | SetVoucherDetail;
